const { normalizeProductPreferences } = require("./productPreferences.cjs");

function normalizeBudget(value) {
  return typeof value === "string" ? value.trim().slice(0, 200) : "";
}

function budgetFromComment(comment) {
  if (typeof comment !== "string") return "";
  const match = comment.match(
    /(?:^|\s*\/\s*)예산\s*:\s*([\s\S]*?)(?=\s*\/\s*(?:플래너 이름|결혼날짜)\s*:|$)/
  );
  return normalizeBudget(match && match[1]);
}

function weddingDateFromComment(comment) {
  if (typeof comment !== "string") return "";
  const match = comment.match(/(?:^|\s*\/\s*)결혼(?:날짜|식 예정일)\s*:\s*([\s\S]*?)(?=\s*\/\s*(?:예산|플래너 이름)\s*:|$)/);
  return match ? match[1].trim().slice(0, 100) : "";
}

function buildConsultationInfo({ preferences, budget, estimateBudget, weddingDate, requestMemo, comment } = {}) {
  return {
    preferences: normalizeProductPreferences(
      Array.isArray(preferences)
        ? preferences.filter((item) => typeof item === "string")
        : []
    ),
    requestMemo: typeof requestMemo === "string" ? requestMemo.trim().slice(0, 500) : "",
    budget: normalizeBudget(budget) || normalizeBudget(estimateBudget) || budgetFromComment(comment),
    weddingDate: typeof weddingDate === "string"
      ? weddingDate.trim().slice(0, 100) : weddingDateFromComment(comment),
  };
}

function getConsultationInfo(schedule = {}) {
  // A saved snapshot remains authoritative even when deliberately empty.
  if (schedule.consultationInfo) {
    return buildConsultationInfo({
      preferences: schedule.consultationInfo.preferences,
      estimateBudget: schedule.consultationInfo.budget,
      requestMemo: schedule.consultationInfo.requestMemo,
      weddingDate: typeof schedule.consultationInfo.weddingDate === "string"
        ? schedule.consultationInfo.weddingDate : weddingDateFromComment(schedule.comment),
    });
  }
  return buildConsultationInfo({
    estimateBudget: schedule.estimate && schedule.estimate.budgetRange,
    comment: schedule.comment,
  });
}

module.exports = { buildConsultationInfo, getConsultationInfo };
